export default __webpack_public_path__ + "static/media/default.4f587ed1eb4e0115113d08a06df7e9ce.svg";